import { IGetServicePickerWidgetInitialState } from '../getInitialState';
import { getOffer } from '../getOffer';
import { getUser } from '../getUser';
import { getExperiments } from '../getExperiments';
import { getDynamicPricingAttributes } from '../getDynamicPricingAttributes';
import { defaultTo } from 'lodash';
import { IPrepareInitialStateResult, IPrepareParams } from './types';

export const prepareServicePickerWidgetInitialState = async (
  params: IPrepareParams,
  initialState: IGetServicePickerWidgetInitialState,
): Promise<IPrepareInitialStateResult> => {
  const [offer, user, experiments, dynamicPricingAttributes] = await Promise.all([
    getOffer(params),
    getUser(params),
    getExperiments(params),
    getDynamicPricingAttributes(params),
  ]);

  return {
    ...initialState,
    offer: defaultTo(offer, undefined),
    user: defaultTo(user, undefined),
    experiments: defaultTo(experiments, undefined),
    dynamicPricingAttributes,
  };
};
